import {ValueObject} from '@s-ui/domain'

import {AppointmentSellerEntity} from '../Entities/AppointmentSellerEntity.js'

/**
 * @implements ValueObject
 */
export class ConfirmAppointmentSellerValueObject extends ValueObject {
  /**
   * @param {Object}  deps
   * @param {String}  deps.dealerId
   * @param {AppointmentSellerEntity}  deps.appointment
   */

  contructor({dealerId, appointment}) {
    this._dealerId = dealerId
    this._appointment = appointment
  }

  static create = ({dealerId, appointment}) => new ConfirmAppointmentSellerValueObject({dealerId, appointment})

  static createFromApi = ({appointmentId, dealerId, appointment}) => {
    const {from, to} = appointment
    const appointmentSellerEntity = AppointmentSellerEntity.create({
      id: appointmentId,
      from,
      to
    })

    return ConfirmAppointmentSellerValueObject.create({
      dealerId,
      appointment: appointmentSellerEntity
    })
  }

  toJSON() {
    return {
      dealerId: this._dealerId,
      appointment: this._appointment.toJSON()
    }
  }
}
